<template>
  <div>
    <b-button
      id="offerAcceptanceSelectButton"
      type="is-blue"
      expanded
      class="has-text-weight-medium mt-4"
      @click="openModal"
      >{{ $t("af:offer_details.modal.acceptance.button.select") }}</b-button
    >
  </div>
</template>

<script>
import EmailConfirmationModal from "../EmailConfirmationModal";
import OfferAcceptanceModal from "./OfferAcceptanceModal";

export default {
  name: "OfferAcceptanceModalWrapper",
  components: {},
  props: {
    offerId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    async openModal() {
      let isEmailConfirmedResponse = await this.$store.dispatch(
        "profile/isEmailConfirmed"
      );
      let isEmailConfirmed = isEmailConfirmedResponse.isEmailConfirmed;
      let currentEmail = isEmailConfirmedResponse.currentEmail;

      if (isEmailConfirmed) {
        this.$buefy.modal.open({
          parent: this,
          component: OfferAcceptanceModal,
          hasModalCard: true,
          trapFocus: true,
          canCancel: false,
          props: {
            offerId: this.offerId,
          },
        });
      } else {
        this.$buefy.modal.open({
          parent: this,
          component: EmailConfirmationModal,
          hasModalCard: true,
          trapFocus: true,
          canCancel: false,
          props: {
            currentEmail: currentEmail,
          },
        });

        await this.$store.dispatch("profile/updateCustomerEmailConfirm", {
          offerId: this.offerId,
        });
      }
    },
  },
};
</script>
